import firebase, {getAuthUid} from "./fire";
import {db, auth} from "./fire";
import {addDays} from "../components/Utilities/DateTimeUtils";

/* this page contains all backend functions regarding user feedback
this functions saves data in two places:
1. after publishing feedbacks forms a list(object with userids as keys) of debaters that should get feedback is saved under the chair at:
"Debaters/chairid/FeedbacksToFill/eventid"
every chair
after the chair fills the feedback the user id is deleted from the object

2. when a chair fills a feedback the data is saved under "Feedbacks/eventid"
this doc contains an object with all the feedbacks from the event with userid (whos the feedback on) as key
*/

/* this function puclish feedbacks. it itirate on every room,
 if a room has juniors to fill feedback on it adds them to the list of debaters the chair should fill feedback on
  */
export function publish_feedbacks(assignment, event) {
    let batch = db.batch();
    //create feedback doc for event
    let allFeedbackRef = db.collection("Feedbacks").doc(event.id);
    batch.set(allFeedbackRef, {});
    let eventRef = db.collection("Events").doc(event.id);
    batch.update(eventRef, {requestedFeedbacks: true});
    let rooms = assignment.rooms;
    for (let room in rooms) {
        //update feedback in chair
        if (rooms[room].Chair[0] && !rooms[room].Chair[0].uid.includes("Fake")) {
            let chair = rooms[room].Chair[0];
            let debatersToFeedback = getDebatersToFeedback(rooms[room]);
            if (Object.keys(debatersToFeedback).length !== 0) {
                let chairFeedBackref = db
                    .collection("Debaters")
                    .doc(chair.uid)
                    .collection("FeedbacksToFill")
                    .doc(event.id);

                batch.set(chairFeedBackref, {
                    event: event,
                    record: getMinimalRoomRecord(rooms[room]),
                    debaters: debatersToFeedback
                });
            }
        }
    }
    return batch.commit();
}

/* input: an assinmentroom output
all debaters in the room who should get feedback with their positions as inner field
  */
export function getDebatersToFeedback(room) {
    let debatersToFeedback = {};
    let debater;
    for (let position in room) {
        if (position === "Chair") {
            continue;
        }
        for (debater in room[position]) {
            debater = room[position][debater];
            if (shouldGetFeedback(debater)) {
                debater = {position, ...debater};
                debatersToFeedback = {
                    [debater.uid]: debater,
                    ...debatersToFeedback
                };
            }
        }
    }
    return debatersToFeedback;
}

export function getMinimalRoomRecord(room) {
    let debatersRecord = {};
    let debater;
    for (let position in room) {
        for (debater in room[position]) {
            debater = room[position][debater];
            if (debater.uid) {
                debatersRecord = {
                    [debater.uid]: {full_name_eng: debater.full_name_eng, position},
                    ...debatersRecord
                };
            }
        }
    }
    return debatersRecord;
}

/*  return if debater should get feedback */
function shouldGetFeedback(debater) {
    if (debater.uid && debater.uid.includes("FAKE")) {
        return false;
    }
    if (debater.rank === "Junior") {
        return true;
    }
    return false;
}

/*  returns all the users a chair should fill feedback on */
export function get_chair_feedbacks(user) {
    let p = new Promise((resolve, reject) => {
        let twoWeeksAgo = addDays(new Date(), -14); // we only want event future events (keep events one day after they happend)

        let result = {};
        // if (user.permissions === "Admin") {
        //     db.collectionGroup('FeedbacksToFill')
        //         .where('event.time', '>=', twoWeeksAgo)
        //         .get()
        //         .then(feedbacks => {
        //             feedbacks.forEach(feedback => {
        //                 result = {[feedback.id]: feedback.data(), ...result};
        //             });
        //             resolve(result);
        //         })
        //         .catch(error => {
        //             reject(error);
        //         });
        // } else {
            db.collection("Debaters")
                .doc(getAuthUid())
                .collection("FeedbacksToFill")
                .where("event.time", ">=", twoWeeksAgo) // dont show feedbacks older then two weeks
                .get()
                .then(feedbacks => {
                    feedbacks.forEach(feedback => {
                        result = {[feedback.id]: feedback.data(), ...result};
                    });
                    resolve(result);
                })
                .catch(error => {
                    reject(error);
                });
        // }
    });
    return p;
}

function getRank(ranks, position) {
    switch (position) {
        case "Opening Government":
            return ranks[0];
        case "Opening Opposition":
            return ranks[1];
        case "Closing Government":
            return ranks[2];
        default:
            return ranks[3];
    }

}


/* this function saves the ranks Personal Feedbacks collection and delete the ranks requirement for this event for this chair */
export function add_ranks_no_event(eventId, record, ranks, finished) {
    const batch = db.batch();

    let p = new Promise((resolve, reject) => {
        for (let [participantUid, participant] of Object.entries(record)) {
            if (participant.position !== "Chair" && participant.position !== "Panel" && !participantUid.includes("FAKE")) {
                let feedbacksRef = db
                    .collection("Debaters")
                    .doc(participantUid)
                    .collection("PersonalData")
                    .doc("Feedbacks");
                let updateJson = {};
                updateJson[eventId + ".rank"] = parseInt(getRank(ranks, participant.position));
                batch.update(feedbacksRef, updateJson);
            }
        }
        let chairId = Object.entries(record).filter(x => x[1].position === "Chair")[0][0];
        // update chair
        let chairFeedBackref = db
            .collection("Debaters")
            .doc(chairId)
            .collection("FeedbacksToFill")
            .doc(eventId);
        // if chair filled the last feedback delete the event feedback doc
        if (finished) {
            batch.delete(chairFeedBackref);
        } else {
            batch.update(chairFeedBackref, {rank_submitted: true});
        }
        //commit all update together then clean chair feedback if needed
        batch
            .commit()
            .then(() => {
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
    return p;
}

/* this function saves the ranks Personal Feedbacks collection and delete the ranks requirement for this event for this chair */
export function add_ranks(feedback, ranks, finished) {
    const batch = db.batch();

    let p = new Promise((resolve, reject) => {
        for (let [participantUid, participant] of Object.entries(feedback.record)) {
            if (participant.position !== "Chair" && participant.position !== "Panel" && !participantUid.includes("FAKE")) {
                let feedbacksRef = db
                    .collection("Debaters")
                    .doc(participantUid)
                    .collection("PersonalData")
                    .doc("Feedbacks");
                let updateJson = {};
                updateJson[feedback.event.id + ".rank"] = parseInt(getRank(ranks, participant.position));
                batch.update(feedbacksRef, updateJson);
            }
        }
        let chairId = Object.entries(feedback.record).filter(x => x[1].position === "Chair")[0][0];
        // update chair
        let chairFeedBackref = db
            .collection("Debaters")
            .doc(chairId)
            .collection("FeedbacksToFill")
            .doc(feedback.event.id);
        // if chair filled the last feedback delete the event feedback doc
        if (finished) {
            batch.delete(chairFeedBackref);
        } else {
            batch.update(chairFeedBackref, {rank_submitted: true});
        }
        //commit all update together then clean chair feedback if needed
        batch
            .commit()
            .then(() => {
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
    return p;
}

export function add_custom_result(result) {
    let json = {};
    json["CUSTOM" + new Date().valueOf().toString()] = result;
    let p = new Promise((resolve, reject) => {
        db
            .collection("Debaters")
            .doc(getAuthUid())
            .collection("PersonalData")
            .doc("Feedbacks")
            .set(json, {merge: true})
            .then(() => resolve())
            .catch(error => reject(error))
    });
    return p;
}

/* this function saves the feedback at the Feedbacks collection and delete the user form the list of feedbacks left for the chair */
export function add_feedback(event, feedbackData, feedbackOnID, finished) {
    const batch = db.batch();

    //update feedbackdata
    feedbackData = {
        event: event,
        feedbackBy: getAuthUid(),
        feedbackOn: feedbackOnID,
        ...feedbackData
    };

    let p = new Promise((resolve, reject) => {
        //update feedback at Feedbacks/eventid
        let feedbackRef = db.collection("Feedbacks").doc(event.id);
        batch.update(feedbackRef, {[feedbackOnID]: feedbackData});

        // update chair
        let chairFeedBackref = db
            .collection("Debaters")
            .doc(getAuthUid())
            .collection("FeedbacksToFill")
            .doc(event.id);
        // if chair filled the last feedback delete the event feedback doc
        if (finished) {
            batch.delete(chairFeedBackref);
        } else {
            batch.update(chairFeedBackref, {
                ["debaters." + [feedbackOnID]]: firebase.firestore.FieldValue.delete()
            });
        }
        //commit all update together then clean chair feedback if needed
        batch
            .commit()
            .then(() => {
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
    return p;
}

/* get event id and retun all the feedbacks that where filled for the event under Feedbacks/eventid */
export function get_all_feedback_for_event(eventId) {
    if (!eventId) return;
    let p = new Promise((resolve, reject) => {
        db.collection("Feedbacks")
            .doc(eventId)
            .get()
            .then(feedbacks => {
                resolve(feedbacks.data());
            })
            .catch(error => {
                reject(error);
            });
    });
    return p;
}
